import { apiClient } from '../client'
import type { OptionsType } from '../../app/modules/types/filters'
import type { LoadTestDetail, LoadTestListResponse } from '../../app/modules/types/loadTest'
import { OWNS_ERRORS } from '../ownsErrors'

/**
 * Load tests — read-only. `api:load_test:view` may be missing, so a 403 is an
 * ordinary answer: every call is `OWNS_ERRORS` and the page renders its own state.
 */
export const loadTestApi = {
  getList: async (params?: string): Promise<LoadTestListResponse> => {
    const url = params ? `/load-tests/?${params}` : '/load-tests/'
    const { data } = await apiClient.get(url, OWNS_ERRORS)
    return data
  },

  getById: async (id: string): Promise<LoadTestDetail> => {
    const { data } = await apiClient.get(`/load-tests/${id}/`, OWNS_ERRORS)
    return data
  },

  getFilterOptions: async (): Promise<NonNullable<OptionsType>> => {
    const { data } = await apiClient.get('/load-tests/filter/', OWNS_ERRORS)
    if (!data || typeof data !== 'object') return {}
    const sanitized: Record<string, unknown> = {}
    for (const [category, value] of Object.entries(data)) {
      sanitized[category] = Array.isArray(value) ? value.filter((item) => item?.name != null) : value
    }
    return sanitized as NonNullable<OptionsType>
  },
}
